var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field } from 'formik';
import React from 'react';
import { LabeledInput } from './CustomTextField.Styles';
export var CustomTextField = function (props) {
    return (React.createElement(Field, __assign({}, props, { component: LabeledInput, variant: 'outlined', margin: 'dense', InputLabelProps: {
            shrink: true
        }, InputProps: {
            notched: false
        } })));
};
CustomTextField.defaultProps = {
    type: 'text'
};
//# sourceMappingURL=CustomTextField.js.map